module.exports = __webpack_public_path__ + "static/Qualcomm_snapdragon_logo-bf5d2084b48197d4494ffc913969f379.svg";